export const SET_PAGE_TITLE = "SET_PAGE_TITLE";
export const QUERY_STRING_CHANGED = "QUERY_STRING_CHANGED";
export const SET_QUERY_STRING = "SET_QUERY_STRING";
export const SET_QUERY_STRING_SINGLE_PARAM = "SET_QUERY_STRING_SINGLE_PARAM";
export const ADD_TO_QUERY_STRING = "ADD_TO_QUERY_STRING";